import { graphql, useStaticQuery } from "gatsby";

function fosfecCMSQuery() {
    const data = useStaticQuery(graphql`
    query contentfulFormFosfec{
        form: allContentfulContactenos(
            filter: { contentful_id: { eq: "2Dt7RbXjhVb2PATGaDcCLD" } }
        ) {
            nodes {
                tituloPrincipal
                descripcionFormulario {
                    raw
                }
                descripcion {
                    raw
                }
                metaTitulo
                tituloFormulario
                titulosFormulario {
                    tituloGeneral
                    contentful_id
                    descripcion {
                        raw
                    }
                    referenciaFormulario {
                        tipoCampo
                        listaSelect
                        mensajeError
                        inputPrincipal
                        nombreId
                        tituloBotonTerminos
                        textoTerminos {
                            raw
                        }
                        obligatorio
                        seccion
                        tabOrder
                    }
                    tituloBoton
                    listaImagenes {
                        url
                        filename
                        title
                        description
                        contentful_id
                      }
                }
                imagenFormulario {
                    file {
                             url
                         }
                 }
                 imagenesEmpleo {
                    file {
                        url
                    }
                 }
            }
        }
        modalBlockActaullyWorking: allContentfulContactenos(
            filter: { contentful_id: { eq: "39gqvVkU3GniNSOzhsiXld" } }
        ) {
            nodes {
                tituloPrincipal
                descripcionFormulario {
                    raw
                }
                descripcion {
                    raw
                }
                metaTitulo
                imagenFormulario {
                    file {
                        url
                    }
                }
                tituloBoton
                redireccionBoton
                tituloBotonOpcional
                redireccionBotonOpcional
                contentful_id
            }
        }
        modalBlockRecivedPension: allContentfulContactenos(
            filter: { contentful_id: { eq: "1dtWVrCs1cHkIoKFITD7vp" } }
        ) {
            nodes {
                tituloPrincipal
                descripcionFormulario {
                    raw
                }
                descripcion {
                    raw
                }
                metaTitulo
                imagenFormulario {
                    file {
                        url
                    }
                }
                tituloBoton
                redireccionBoton
                tituloBotonOpcional
                redireccionBotonOpcional
                contentful_id
            }
        }
        modalBlockDifferentCompensationFund: allContentfulContactenos(
            filter: { contentful_id: { eq: "4KnetO6fuQtoUqhYyydlJZ" } }
        ) {
            nodes {
                tituloPrincipal
                descripcionFormulario {
                    raw
                }
                descripcion {
                    raw
                }
                metaTitulo
                imagenFormulario {
                    file {
                        url
                    }
                }
                tituloBoton
                redireccionBoton
                tituloBotonOpcional
                redireccionBotonOpcional
                contentful_id
            }
        }
        modalBlockedNotRegisteredSISE: allContentfulContactenos(
            filter: { contentful_id: { eq: "402uLVo4v1tMuIwN5SUeVA" } }
        ) {
            nodes {
                tituloPrincipal
                descripcionFormulario {
                    raw
                }
                descripcion {
                    raw
                }
                metaTitulo
                imagenFormulario {
                    file {
                        url
                    }
                }
                tituloBoton
                redireccionBoton
                tituloBotonOpcional
                redireccionBotonOpcional
                contentful_id
            }
        }
          modalConfirmationMessage: allContentfulContactenos(
                filter: { contentful_id: { eq: "1QKV3gRLU6h1UN5nD4UZ9V" } }
            ) {
                nodes {
                    tituloPrincipal
                    descripcionFormulario {
                        raw
                    }
                    descripcion {
                        raw
                    }
                    metaTitulo
                    imagenFormulario {
                        file {
                            url
                        }
                    }
                    tituloBoton
                    redireccionBoton
                    tituloBotonOpcional
                    redireccionBotonOpcional
                    contentful_id
                }
            }
            modalEmploymentPath: allContentfulContactenos(
                filter: { contentful_id: { eq: "29RvwkSzH8UVH1WNeVpRu2" } }
            ) {
                nodes {
                    tituloPrincipal
                    descripcionFormulario {
                        raw
                    }
                    descripcion {
                        raw
                    }
                    metaTitulo
                    imagenFormulario {
                        file {
                            url
                        }
                    }
                    tituloBoton
                    redireccionBoton
                    tituloBotonOpcional
                    redireccionBotonOpcional
                    contentful_id
                }
            }
    }
    `);
    return data;
}

export default fosfecCMSQuery;
